export var SearchSource;
(function (SearchSource) {
    SearchSource["HomeDashboard"] = "HomeDashboard";
    SearchSource["LogzPage"] = "LogzPage";
    SearchSource["LogzAlert"] = "LogzAlert";
    SearchSource["LogzAppRoute"] = "LogzAppRoute";
    SearchSource["LogzAction"] = "LogzAction";
    SearchSource["OsdVisualization"] = "OsdVisualization";
    SearchSource["OsdDashboard"] = "OsdDashboard";
    SearchSource["OsdSavedSearch"] = "OsdSavedSearch";
    SearchSource["OsdIndex"] = "OsdIndex";
    SearchSource["OsdConfig"] = "OsdConfig";
    SearchSource["OsdTimelion"] = "OsdTimelion";
    SearchSource["OsdAction"] = "OsdAction";
    SearchSource["OsdQuery"] = "OsdQuery";
    SearchSource["GrafanaDashboard"] = "GrafanaDashboard";
    SearchSource["GrafanaFolder"] = "GrafanaFolder";
    SearchSource["GrafanaAlert"] = "GrafanaAlert";
    SearchSource["GrafanaPlaylist"] = "GrafanaPlaylist";
    SearchSource["GrafanaSnapshot"] = "GrafanaSnapshot";
    SearchSource["GrafanaAction"] = "GrafanaAction";
    SearchSource["LogzDocs"] = "LogzDocs";
    SearchSource["LogzReport"] = "LogzReport";
    SearchSource["LogzNotificationEndpoint"] = "LogzNotificationEndpoint";
    SearchSource["JaegerService"] = "JaegerService";
    SearchSource["JaegerAction"] = "JaegerAction";
    SearchSource["Explore"] = "Explore";
    SearchSource["ExploreSavedSearch"] = "ExploreSavedSearch";
    SearchSource["UnifiedDashboard"] = "UnifiedDashboard";
})(SearchSource || (SearchSource = {}));
export const mapAppStateToSearchSource = {
    'dashboard.osd': SearchSource.OsdDashboard,
    'dashboard.metrics': SearchSource.GrafanaDashboard,
    'dashboard.view-dashboard': SearchSource.UnifiedDashboard,
};
export class GlobalSearchResultModel {
    title;
    subtitle;
    source;
    state;
    link;
    description;
    createdBy;
    createdAt;
    updatedAt;
    updatedBy;
    visitCount;
}
//# sourceMappingURL=global-search-result.js.map